/**
 * Construye la URL de validación de geolocalización.
 * @param {number|string} shopId - ID del local (shop)
 * @param {number|string} shopBranchId - ID de la sucursal
 * @param {string} address - Dirección codificada
 * @param {string} locality - Localidad codificada
 */
export function buildGeolocationValidateUrl(shopId, shopBranchId, address, locality) {
  const baseUrl = process.env.REACT_APP_API_LOCALIZATION_VALIDATE_ROUTE;
  if (!baseUrl || !shopId || !shopBranchId) {
    return null;
  }
  const params = new URLSearchParams({
    address,
    locality,
    shopBranchId: String(shopBranchId),
  });
  return `${baseUrl}${shopId}?${params.toString()}`;
}
